var _path, _path2, _line, _line2, _line3, _line4, _line5, _line6, _line7, _path3, _path4, _path5, _path6, _line8, _line9, _line0, _line1, _line10, _line11, _path7, _path8, _path9, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckListMutiple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 90,
    viewBox: "0 0 174 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.5 13.4951V3.96747L115.931 13.4951L102.5 13.4951Z",
    fill: "#E78524",
    stroke: "#E78524"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102 3.5H66C64.8954 3.5 64 4.39543 64 5.5V32.5V72.5C64 73.6046 64.8954 74.5 66 74.5H115C116.105 74.5 117 73.6046 117 72.5V32.5V14",
    stroke: "#E78524"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 64,
    y1: 32,
    x2: 117,
    y2: 32,
    stroke: "#E78524"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 78,
    y1: 45,
    x2: 83,
    y2: 45,
    stroke: "#E78524"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 78,
    y1: 51,
    x2: 83,
    y2: 51,
    stroke: "#E78524"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 97,
    y1: 45,
    x2: 102,
    y2: 45,
    stroke: "#E78524"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 97,
    y1: 51,
    x2: 102,
    y2: 51,
    stroke: "#E78524"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 88,
    y1: 45,
    x2: 93,
    y2: 45,
    stroke: "#E78524"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 88,
    y1: 51,
    x2: 93,
    y2: 51,
    stroke: "#E78524"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5518 8.04545L70.7557 10.169L71.9702 8.04545H73.1314L71.4304 10.7727L73.1456 13.5H71.9844L70.7557 11.4616L69.5305 13.5H68.3658L70.0632 10.7727L68.3871 8.04545H69.5518ZM75.2834 6.22727V13.5H74.2216V6.22727H75.2834ZM80.7992 9.37713L79.8368 9.54759C79.7966 9.42448 79.7327 9.30729 79.6451 9.19602C79.5598 9.08475 79.4438 8.99361 79.2971 8.92259C79.1503 8.85156 78.9668 8.81605 78.7466 8.81605C78.446 8.81605 78.195 8.88352 77.9938 9.01847C77.7926 9.15104 77.6919 9.32268 77.6919 9.53338C77.6919 9.71567 77.7594 9.86245 77.8944 9.97372C78.0293 10.085 78.2471 10.1761 78.5478 10.2472L79.4142 10.446C79.9161 10.562 80.2902 10.7408 80.5364 10.9822C80.7826 11.2237 80.9057 11.5374 80.9057 11.9233C80.9057 12.25 80.811 12.5412 80.6216 12.7969C80.4346 13.0502 80.173 13.2491 79.8368 13.3935C79.503 13.5379 79.1159 13.6101 78.6756 13.6101C78.0648 13.6101 77.5665 13.4799 77.1806 13.2195C76.7947 12.9567 76.5579 12.5838 76.4703 12.1009L77.4966 11.9446C77.5605 12.2121 77.6919 12.4145 77.8908 12.5518C78.0897 12.6868 78.3489 12.7543 78.6685 12.7543C79.0165 12.7543 79.2947 12.6821 79.503 12.5376C79.7114 12.3909 79.8155 12.2121 79.8155 12.0014C79.8155 11.831 79.7516 11.6877 79.6238 11.5717C79.4983 11.4557 79.3053 11.3681 79.0449 11.3089L78.1216 11.1065C77.6126 10.9905 77.2362 10.8059 76.9924 10.5526C76.7509 10.2992 76.6301 9.97846 76.6301 9.5902C76.6301 9.26823 76.7201 8.98651 76.9 8.74503C77.08 8.50355 77.3285 8.31534 77.6458 8.1804C77.963 8.04309 78.3264 7.97443 78.736 7.97443C79.3255 7.97443 79.7895 8.10227 80.128 8.35795C80.4666 8.61127 80.6903 8.95099 80.7992 9.37713ZM82.9112 8.04545L84.1151 10.169L85.3295 8.04545H86.4908L84.7898 10.7727L86.505 13.5H85.3438L84.1151 11.4616L82.8899 13.5H81.7251L83.4226 10.7727L81.7464 8.04545H82.9112Z",
    fill: "#E78524"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M155.421 29.8255L160.328 21.6587L166.933 36.743L155.421 29.8255Z",
    fill: "#E78524",
    stroke: "#E78524"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M160.14 21.0003L129.282 2.45898C128.335 1.89008 127.107 2.19644 126.538 3.14324L120.1 13.8578L117 18.5005M167.59 37.7262L158.061 53.5838L137.472 87.8496C136.899 88.8045 135.655 89.1065 134.707 88.5213L112 74.5004",
    stroke: "#E78524"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M158.319 53.1553L135.604 39.5068L117 28.0005",
    stroke: "#E78524"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 118.194,
    y1: 44.2116,
    x2: 122.48,
    y2: 46.7867,
    stroke: "#E78524"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 115.104,
    y1: 49.3546,
    x2: 119.39,
    y2: 51.9298,
    stroke: "#E78524"
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 134.48,
    y1: 53.9977,
    x2: 138.766,
    y2: 56.5729,
    stroke: "#E78524"
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    x1: 131.39,
    y1: 59.1403,
    x2: 135.676,
    y2: 61.7155,
    stroke: "#E78524"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 126.766,
    y1: 49.3619,
    x2: 131.051,
    y2: 51.9371,
    stroke: "#E78524"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 123.675,
    y1: 54.505,
    x2: 127.961,
    y2: 57.0802,
    stroke: "#E78524"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M129.985 8.18452L129.924 10.6248L132.058 9.43005L133.054 10.0281L130.191 11.4898L130.257 14.7109L129.261 14.1128L129.258 11.7328L127.158 12.849L126.159 12.2491L129.019 10.7856L128.987 7.58462L129.985 8.18452ZM135.835 9.57799L132.089 15.8119L131.179 15.2651L134.925 9.03113L135.835 9.57799ZM138.94 15.1188L138.028 14.7693C138.057 14.643 138.062 14.5096 138.044 14.3691C138.029 14.2299 137.976 14.092 137.887 13.9555C137.798 13.819 137.659 13.6941 137.47 13.5807C137.212 13.4259 136.962 13.3544 136.72 13.3665C136.48 13.3765 136.305 13.4718 136.197 13.6524C136.103 13.8086 136.085 13.9692 136.143 14.1341C136.202 14.299 136.341 14.4893 136.563 14.705L137.203 15.3217C137.573 15.6796 137.802 16.0255 137.888 16.3593C137.975 16.6931 137.919 17.0254 137.72 17.3562C137.552 17.6362 137.321 17.837 137.027 17.9586C136.736 18.0794 136.41 18.1152 136.047 18.0658C135.686 18.0177 135.317 17.8802 134.94 17.6534C134.416 17.3388 134.056 16.9706 133.86 16.5486C133.664 16.1246 133.653 15.6831 133.827 15.224L134.787 15.6186C134.704 15.8808 134.713 16.122 134.812 16.3421C134.913 16.5602 135.101 16.7516 135.375 16.9162C135.673 17.0954 135.949 17.1768 136.202 17.1603C136.456 17.1418 136.637 17.0422 136.746 16.8616C136.833 16.7155 136.852 16.5598 136.803 16.3945C136.755 16.2305 136.635 16.056 136.442 15.8712L135.755 15.2221C135.378 14.8606 135.151 14.5084 135.072 14.1657C134.995 13.8242 135.057 13.487 135.257 13.1542C135.423 12.8782 135.645 12.6831 135.924 12.5688C136.202 12.4544 136.512 12.4211 136.854 12.4689C137.196 12.5146 137.543 12.6429 137.894 12.8538C138.4 13.1574 138.732 13.506 138.89 13.8995C139.05 14.291 139.067 14.6974 138.94 15.1188ZM141.437 15.0651L141.375 17.5054L143.51 16.3106L144.505 16.9087L141.642 18.3704L141.708 21.5915L140.712 20.9934L140.709 18.6134L138.609 19.7296L137.611 19.1297L140.47 17.6662L140.438 14.4652L141.437 15.0651Z",
    fill: "#E78524"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4064 17.7221L33.4993 9.55532L49.919 10.8046L38.4064 17.7221Z",
    fill: "#E78524",
    stroke: "#E78524"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8299 9.41195L1.97186 27.9533C1.02506 28.5222 0.718703 29.7509 1.2876 30.6977L15.1936 53.8412L35.7809 88.1042C36.3553 89.0602 37.6007 89.3616 38.5488 88.7741L64 73.0005M51.0953 10.6866L60.6235 26.5442L64 32.5005",
    stroke: "#E78524"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 14.9361,
    y1: 53.4127,
    x2: 60.366,
    y2: 26.1157,
    stroke: "#E78524"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 33.6319,
    y1: 57.3453,
    x2: 37.9178,
    y2: 54.7702,
    stroke: "#E78524"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 36.7222,
    y1: 62.4884,
    x2: 41.008,
    y2: 59.9132,
    stroke: "#E78524"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 49.9181,
    y1: 47.5597,
    x2: 54.2039,
    y2: 44.9845,
    stroke: "#E78524"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 53.0084,
    y1: 52.7023,
    x2: 57.2942,
    y2: 50.1271,
    stroke: "#E78524"
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 42.2036,
    y1: 52.195,
    x2: 46.4894,
    y2: 49.6198,
    stroke: "#E78524"
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 45.2938,
    y1: 57.338,
    x2: 49.5797,
    y2: 54.7628,
    stroke: "#E78524"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M7.35747 30.0201L9.48308 31.2203L9.43038 28.7746L10.4257 28.1765L10.3723 31.3903L13.2472 32.8446L12.2518 33.4427L10.1488 32.3283L10.1485 34.7065L9.1501 35.3064L9.20044 32.0944L6.35906 30.62L7.35747 30.0201ZM11.3339 25.5096L15.0796 31.7436L14.1695 32.2904L10.4238 26.0565L11.3339 25.5096ZM17.6842 25.3687L16.9471 26.0105C16.8492 25.9257 16.734 25.8582 16.6016 25.8079C16.4713 25.7564 16.3249 25.7381 16.1625 25.7528C16.0001 25.7675 15.8245 25.8316 15.6358 25.945C15.3781 26.0998 15.1977 26.2869 15.0948 26.5062C14.9906 26.7235 14.9927 26.9224 15.1012 27.103C15.1951 27.2593 15.3285 27.3503 15.5015 27.3762C15.6745 27.4021 15.9081 27.368 16.2024 27.2741L17.0476 26.9983C17.5375 26.8392 17.9502 26.7998 18.2856 26.8799C18.621 26.9601 18.8881 27.1656 19.0869 27.4964C19.2551 27.7764 19.3239 28.0748 19.2933 28.3915C19.2634 28.7049 19.1416 29.0101 18.9278 29.3071C18.7161 29.6028 18.4215 29.864 18.044 30.0908C17.5205 30.4054 17.0263 30.5505 16.5614 30.526C16.0953 30.4995 15.7003 30.3018 15.3765 29.9329L16.1757 29.2704C16.3683 29.4668 16.5851 29.5727 16.8263 29.5879C17.0663 29.6012 17.3232 29.5255 17.5972 29.3609C17.8955 29.1817 18.0967 28.9765 18.2009 28.7454C18.3039 28.5123 18.3011 28.3054 18.1926 28.1248C18.1048 27.9787 17.9763 27.8889 17.8069 27.8553C17.6396 27.8205 17.4291 27.8448 17.1754 27.9281L16.2798 28.2302C15.7837 28.3929 15.366 28.4285 15.0265 28.3369C14.689 28.2442 14.4203 28.0314 14.2204 27.6986C14.0545 27.4226 13.9865 27.1348 14.0164 26.8351C14.0463 26.5355 14.1624 26.2461 14.3648 25.9671C14.566 25.686 14.8422 25.44 15.1932 25.229C15.6985 24.9254 16.1621 24.796 16.584 24.8408C17.0046 24.8836 17.3714 25.0596 17.6842 25.3687Z",
    fill: "#E78524"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckListMutiple);
export default __webpack_public_path__ + "static/media/checkListMutiple.d699ac051dcfba525a9eab94122e8a52.svg";
export { ForwardRef as ReactComponent };